import { Component, Inject } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
   selector: 'app-confirm-restore',
   templateUrl: 'confirm-restore.component.html',
   styleUrls: ['confirm-restore.component.css']
})
export class ConfirmRestoreComponent {
   progress: boolean;
   name: any;
   isMultiSelect = false;
   itemSelList: any[] = [];
   selectListId: any[] = [];

   constructor(private dialogRef: MatDialogRef<ConfirmRestoreComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any) {

      if (this.data.isMultiSelect) {
         this.isMultiSelect = this.data.isMultiSelect;
         this.itemSelList = this.data.listItem;
         const listIds = [];
         if (this.itemSelList) {
            for (const itemSel of this.itemSelList) {
               listIds.push(itemSel.id);
            }
         }
         this.selectListId = listIds;
      } else {
         this.name = { item: data.item.name };
      }
   }

   restore(restoreButton: MatButton, cancelButton: MatButton) {
      restoreButton.disabled = true;
      cancelButton.disabled = true;
      this.progress = true;
      if (this.isMultiSelect) {
         this.data.service.multipleRestore(this.selectListId)
            .subscribe(
               () => {
                  this.dialogRef.close(true);
                  this.onAlert('alert.confirm_restore');
               },
               error => {
                  this.dialogRef.close();
               });
      } else {
         this.data.service.restore(this.data.item.id)
            .subscribe(
               () => {
                  this.dialogRef.close(true);
                  this.onAlert('alert.confirm_restore');
               },
               error => {
                  this.dialogRef.close();
               });
      }
   }

   onAlert(text: string) {
      this.data.translate.get(text).subscribe(s => {
         this.data.toast.success(s);
      });
   }
}
